import type * as Types from '../base-types.graphql';

import { gql } from '@apollo/client';
import { ScFieldsFragmentDoc, ScWithMinMaxFieldsFragmentDoc } from './share-class.graphql';
export type GqlStFieldsFragment = { blockEnd: string, blockStart: string, buyerId?: string | null, comment?: string | null, createdAt: string, id: string, name?: string | null, currency: Types.GqlCurrency, pricePerShare?: string | null, sellerId?: string | null, shareCertificateDate?: string | null, rounded: Types.GqlStRounded, shareTransactionGroupId?: string | null, updatedAt: string, shareClassFrom?: { name: string, voteWeight: string, quantity?: string | null } | null, shareClassTo?: { name: string, voteWeight: string, quantity?: string | null } | null };

export const StFieldsFragmentDoc = gql`
    fragment StFields on ShareTransaction {
  blockEnd
  blockStart
  buyerId
  comment
  createdAt
  id
  name
  currency
  pricePerShare
  sellerId
  shareCertificateDate
  rounded
  shareClassFrom {
    ...ScFields
  }
  shareClassTo {
    ...ScFields
  }
  shareTransactionGroupId
  updatedAt
}
    ${ScFieldsFragmentDoc}`;